import { URL_PROD } from "../constants/urls";

export const resizeImage = (
  url: string,
  width: number,
  height: number,
  quality: number,
) => {
  if (!url) return url;
  return `${URL_PROD}/default/image-tool-lambda?new-width=${width}&new-height=${height}&new-quality=${quality}&url-image=${encodeURIComponent(
    url,
  )}`;
};
